import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router'
// import Settings from '../codeArt/external/reducers/Settings';
// import Auth from './Auth';
import Devices from './Devices';
import Comparator from './Comparator';
import DeviceStatistics from './DeviceStatistics';
import RankIndicators from './RankIndicators';

// export default (history) => combineReducers({
//   router: connectRouter(history),
//   settings: Settings,
//   auth: Auth,
// });


export default {
  Devices,
  DeviceStatistics,
  Comparator,
  RankIndicators
}
